export const CONFIG = {
  "PROJECTNAME": "aksa",
  "COMPANYNAME": "Aksa",
  "DFTLNGCODE": "de",
  "URL": "https://api.fbsshop.de",
  "PAYMENTSERVER": "https://stripe.mobiapi.de",
  "VENDORID": "10004001",
  "IMAGEURL": "/images",
  "PAYMENTSYSTEM": false,
  "BANNER": false,
  "BRANDS": false,
  "FLAG_ITEM_ON_HAND": false,
  "MENU_LOGO_BACKGROUND": false,
  "LOGO_LOGIN_BACKGROUND": false,
  "MENU_WHITE_BACKGROUND": false,
  "colors": {
    "primary": "rgb(187,60,53)",
    "primary100": "#d6d7df",
    "light": "rgb(187,60,53)",
    "secondary": "rgb(187,60,53)",
    "dark": "rgb(187,60,53)",
    "siteColor3": "#fff",
    "menuSecondary": "rgb(187,60,53)"
  }
};